/* SNEAP product cards: colour swatches, quick add, quick view */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});
  if (S.__cards) return;
  S.__cards = true;
  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(S.url('products/' + encodeURIComponent(handle) + '.js'), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error((S.t||{}).not_found || 'Product not found'); return r.json(); });
    }
    return cache[handle];
  }
  function img(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- Swatches on cards ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sn-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-sn-card]');
    card.querySelectorAll('[data-sn-swatch]').forEach(function (b) { var on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    card.dataset.variant = sw.dataset.variant;
    var lab = card.querySelector('[data-sn-card-color]'); if (lab) lab.textContent = sw.dataset.name;
    var im = card.querySelector('.sn-card__img:not(.sn-card__img--2)');
    if (im && sw.dataset.img) { im.removeAttribute('srcset'); im.src = sw.dataset.img; }
    var add = card.querySelector('[data-sn-quick-add]');
    if (add) add.disabled = sw.dataset.avail === 'false';
  });

  /* ---------- Quick add ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sn-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('[data-sn-card]');
    if (card.dataset.single === 'true' || card.dataset.colorOnly === 'true') {
      S.addToCart([{ id: Number(card.dataset.variant), quantity: 1 }], b).catch(function () {});
    } else {
      openQuickView(card.dataset.handle, b, card.dataset.variant);
    }
  });

  /* ---------- Quick view ---------- */
  var modal, box, opener;
  function ensureModal() {
    if (modal) return;
    var ov = document.createElement('div'); ov.className = 'sn-overlay'; ov.setAttribute('data-sn-qv-overlay', '');
    modal = document.createElement('div');
    modal.className = 'sn-ui sn-modal sn-qv';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', (S.t||{}).quick_view || 'Quick view'); modal.setAttribute('aria-hidden', 'true'); modal.setAttribute('inert', '');
    modal.innerHTML = '<div class="sn-modal__box"><button type="button" class="sn-icon-btn sn-modal__close" data-sn-close aria-label="' + S.esc((S.t||{}).close || 'Close') + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="sn-ic"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div data-sn-qv-body></div></div>';
    document.body.appendChild(ov); document.body.appendChild(modal);
    box = modal.querySelector('[data-sn-qv-body]');
    modal.addEventListener('click', function (e) { if (e.target === modal) closeQV(); });
    modal.querySelector('[data-sn-close]').addEventListener('click', closeQV);
    ov.addEventListener('click', closeQV);
  }
  function closeQV() {
    if (!modal) return;
    modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); modal.setAttribute('inert', '');
    document.querySelector('[data-sn-qv-overlay]').classList.remove('is-open');
    S.unlock(modal);
  }
  function isColor(name) { return /^(color|colour|farbe|couleur)$/i.test(name); }
  function cssColor(v) { return String(v).toLowerCase().replace(/[^a-z]/g, ''); }

  function openQuickView(handle, from, variantId) {
    ensureModal();
    opener = from;
    var T = S.qvTexts || {};
    box.innerHTML = '<div class="sn-qv__loading">' + S.esc(T.loading || (S.t||{}).loading || 'Loading…') + '</div>';
    modal.removeAttribute('inert'); modal.setAttribute('aria-hidden', 'false'); modal.classList.add('is-open');
    document.querySelector('[data-sn-qv-overlay]').classList.add('is-open');
    S.lock(modal, from);
    getProduct(handle).then(function (p) { render(p, variantId); }).catch(function (er) { box.innerHTML = '<div class="sn-qv__loading">' + S.esc(er.message) + '</div>'; });
  }

  function render(p, variantId) {
    var T = S.qvTexts || {};
    var cur = p.variants.filter(function (v) { return String(v.id) === String(variantId); })[0] || p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var single = p.variants.length === 1;
    var imgs = (p.media && p.media.length ? p.media.map(function (m) { return { src: (m.preview_image && m.preview_image.src) || m.src, id: m.id }; }) : (p.images || []).map(function (s) { return { src: s }; }));
    var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? { name: o, values: [] } : o; });
    var html = '<div class="sn-qv__grid"><div class="sn-qv__media"><div class="sn-qv__track" data-qv-track>' +
      imgs.map(function (m, i) { return '<img src="' + S.esc(img(m.src, 900)) + '" alt="' + (i ? '' : S.esc(p.title)) + '" data-media-id="' + (m.id || '') + '" loading="' + (i ? 'lazy' : 'eager') + '">'; }).join('') +
      '</div>' + (imgs.length > 1 ? '<div class="sn-qv__dots" aria-hidden="true">' + imgs.map(function (m, i) { return '<span' + (i ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>' : '') + '</div>' +
      '<div class="sn-qv__info"><h2 class="sn-qv__title">' + S.esc(p.title) + '</h2><p class="sn-qv__price"><b data-qv-price></b><s data-qv-compare></s></p>';
    if (!single) {
      opts.forEach(function (o, i) {
        var color = isColor(o.name);
        html += '<fieldset class="sn-qv__opt" data-qv-opt="' + i + '"><legend>' + S.esc(o.name) + ': <span data-qv-label>' + S.esc(cur.options[i]) + '</span></legend><div class="sn-qv__vals">' +
          o.values.map(function (val) {
            return '<button type="button" class="sn-qv__val' + (color ? ' is-sw' : '') + '" data-val="' + S.esc(val) + '" aria-pressed="' + (val === cur.options[i]) + '"' + (color ? ' aria-label="' + S.esc(val) + '" title="' + S.esc(val) + '"' : '') + '>' +
              (color ? '<span style="background:' + S.esc(cssColor(val)) + '"></span>' : S.esc(val)) + '</button>';
          }).join('') + '</div></fieldset>';
      });
    }
    html += '<div class="sn-qv__row"><div class="sn-qty sn-qty--lg"><button type="button" data-qv-q="-1" aria-label="' + S.esc((S.t||{}).decrease || 'Decrease quantity') + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="sn-ic"><path d="M5 12h14"/></svg></button><input type="number" min="1" value="1" aria-label="' + S.esc((S.t||{}).quantity || 'Quantity') + '" data-qv-qty><button type="button" data-qv-q="1" aria-label="' + S.esc((S.t||{}).increase || 'Increase quantity') + '"><svg viewBox="0 0 24 24" aria-hidden="true" class="sn-ic"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
      '<button type="button" class="sn-btn" data-qv-add><span data-label>' + S.esc(T.add || (S.t||{}).add || 'Add to cart') + '</span></button></div>' +
      '<a class="sn-qv__more" href="' + S.esc(p.url) + '">' + S.esc(T.details || (S.t||{}).details || 'View full details') + '</a></div></div>';
    box.innerHTML = html;

    var priceEl = box.querySelector('[data-qv-price]'), cmpEl = box.querySelector('[data-qv-compare]'), addBtn = box.querySelector('[data-qv-add]');
    var track = box.querySelector('[data-qv-track]');
    var dots = [].slice.call(box.querySelectorAll('.sn-qv__dots span'));
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }, { passive: true });

    function selected() { return opts.map(function (o, i) { var b = box.querySelector('[data-qv-opt="' + i + '"] [aria-pressed="true"]'); return b ? b.dataset.val : cur.options[i]; }); }
    function find(sel) { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
    function update() {
      var sel = single ? cur.options : selected();
      var v = single ? cur : find(sel);
      box.querySelectorAll('[data-qv-opt]').forEach(function (fs) {
        var i = Number(fs.dataset.qvOpt);
        fs.querySelector('[data-qv-label]').textContent = sel[i];
        fs.querySelectorAll('[data-val]').forEach(function (b) { var t = sel.slice(); t[i] = b.dataset.val; var x = find(t); b.classList.toggle('is-na', !x || !x.available); });
      });
      if (!v) { addBtn.disabled = true; addBtn.querySelector('[data-label]').textContent = T.unavailable || (S.t||{}).unavailable || 'Unavailable'; return; }
      cur = v;
      priceEl.textContent = S.money(v.price);
      cmpEl.textContent = v.compare_at_price > v.price ? S.money(v.compare_at_price) : '';
      addBtn.disabled = !v.available;
      addBtn.querySelector('[data-label]').textContent = v.available ? (T.add || (S.t||{}).add || 'Add to cart') : (T.sold_out || (S.t||{}).sold_out || 'Sold out');
      var mid = v.featured_media && v.featured_media.id;
      if (mid) { var im = track.querySelector('[data-media-id="' + mid + '"]'); if (im) track.scrollTo({ left: im.offsetLeft, behavior: 'smooth' }); }
    }
    box.querySelectorAll('[data-qv-opt]').forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-val]'); if (!b) return;
        fs.querySelectorAll('[data-val]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        update();
      });
    });
    var qty = box.querySelector('[data-qv-qty]');
    box.querySelectorAll('[data-qv-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qvQ)); }); });
    addBtn.addEventListener('click', function () {
      S.addToCart([{ id: cur.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }], addBtn).then(function () { closeQV(); }).catch(function () {});
    });
    update();
    var f = box.querySelector('.sn-qv__val[aria-pressed="true"], [data-qv-add]'); if (f) f.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sn-quick-view]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-sn-card]');
    openQuickView(card.dataset.handle, b, card.dataset.variant);
  });
  S.quickView = openQuickView;
})();
